import React, { useEffect, useState } from "react";
import TagInputs from "../../layouts/TagInputs";
import notification from "../../../utility/notification";
import { get, post, put } from "../../../utility/fetch";
import { usePatient } from "../../../contexts";
import axios from "axios";
import Spinner from "../../UI/Spinner";

function ContactDetails({ setSelectedTab, empParam, formLoading, hide, setPayload }) {
  const { patientId } = usePatient();
  const [states, setStates] = useState(null);
  const [loading, setLoading] = useState(false);
  const [payload, setLocalPayload] = useState({
    stateOfResidence: "",
    lgaResidence: "",
    city: "",
    homeAddress: "",
    phone: "",
    email: "",
    altPhone: ""
  });

    const {patientInfo, setPatientId, setPatientInfo } = usePatient();
  
  useEffect(() => {
    if(patientInfo){
      setLocalPayload(patientInfo?.contact)
    }
    // getContact();
    fetchStates();
  }, [patientInfo]);

  // const handleChange = (event) => {
  //   const { name, value } = event.target;

  //   if ((name === 'phone' || name === 'altPhone') && (isNaN(value) || value.length > 11)) {
  //     notification({ message: 'Please enter a valid phone number', type: "error" });
  //     return;
  //   }

  //   setPayload(prevPayload => ({ ...prevPayload, [name]: value }));
  // };

  const requiredFields = {
    stateOfResidence: "State Of Residence",
    lgaResidence: "LGA",
    city: "City",
    homeAddress: "Home Address",
    phone: "Phone Number",
    email: "Email Address",
    altPhone: "Alt Phone Number"
  };

  const fetchStates = async () => {
    const token = sessionStorage.getItem('token');
    if (!token) {
      notification({ message: 'Token not found in session storage', type: "error" });
      return;
    }

    const options = {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };

    try {
      let res = await axios.get(`${process.env.REACT_APP_BASE_URL}/clinicapi/api/profile/state/list/1/100`, options);
      let tempDoc = res?.data?.resultList.map((doc) => {
        return { name: doc?.name, value: doc?.name };
      });

      tempDoc?.unshift({ name: "Select State", value: "" });
      setStates(tempDoc);
    } catch (error) {
    }
  };

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  const checkMissingFields = (payload) => {
    const missingFields = Object.keys(requiredFields).filter(field => !payload[field]);
    return missingFields;
  };


  const handleChange = (event) => {
    const { name, value } = event.target;

    if ((name === 'phone' || name === 'altPhone') && (isNaN(value) || value.length > 11)) {
      notification({ message: 'Please enter a valid phone number', type: "error" });
      return;
    }

    setLocalPayload(prevPayload => ({ ...prevPayload, [name]: value }));
  }

  const submitPayload = async () => {
    // Validate phone number
    setLoading(true)
    const missingFields = checkMissingFields(payload);
    if (missingFields.length > 0) {
      const missingFieldLabels = missingFields.map(field => requiredFields[field]);
      notification({ message: `Missing required fields: ${missingFieldLabels.join(", ")}`, type: "error" });
      return;
    }

    if (!payload.phone || payload.phone.length !== 11 || isNaN(payload.phone)) {
      notification({ message: 'Please make sure phone number is 11 digits', type: "error" });
      return;
    }

    if (!payload.altPhone || payload.altPhone.length !== 11 || isNaN(payload.altPhone)) {
      notification({ message: 'Please make sure alt phone number is 11 digits', type: "error" });
      return;
    }

    if (!isValidEmail(payload.email)) {
      notification({ message: 'Please enter a valid email address', type: "error" });
      return;
    }

    try {

      let res = await put(`/patient/${Number(empParam) - 12345}/contact-update`, { ...payload});
      if (res?.statusCode === 200) {
        notification({ message: res?.data?.message, type: "success" });
        setLoading(false)
        // setSelectedTab("emergency");
        }
      } catch (error) {
        notification({ message: error?.response?.data?.errorData[0] || error?.message, type: "error"  });
        setLoading(false)
      }

      setLoading(false)
    };

    const getContact = async () => {
      try {
        let res = await get(`/patients/${Number(patientId)}/contact`);
        if (res) {
          setPayload(res);
        }
      } catch (error) {
        console.error('Error fetching contact details:', error);
      }
    };


    const inputGroupStyle = {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '16px',
    };

    const inputWrapperStyle = {
      flex: 1,
    };

    const loaderStyle = {
      marginLeft: '8px',
      display: 'flex',
      alignItems: 'center',
    };

    return (
      <div>
        <div className="w-50">
          <div className="m-t-40"></div>
          
          {/* Wrap each TagInput in a flex container */}
          <div style={inputGroupStyle}>
            <div style={inputWrapperStyle}>
              <TagInputs 
                type={'select'} 
                onChange={handleChange} 
                disabled={!hide} 
                options={states} 
                value={payload?.stateOfResidence || ''} 
                name="stateOfResidence" 
                label="State Of Residence" 
              />
            </div>
            {formLoading && <div style={loaderStyle}><Spinner width={16} height={16} /></div>}
          </div>

          <div style={inputGroupStyle}>
            <div style={inputWrapperStyle}>
              <TagInputs 
                onChange={handleChange} 
                disabled={!hide} 
                value={payload?.lgaResidence || ''} 
                name="lgaResidence" 
                label="LGA" 
              />
            </div>
            {formLoading && <div style={loaderStyle}><Spinner width={16} height={16} /></div>}
          </div>

          <div style={inputGroupStyle}>
            <div style={inputWrapperStyle}>
              <TagInputs 
                onChange={handleChange} 
                disabled={!hide} 
                value={payload?.city || ''} 
                name="city" 
                label="City" 
              />
            </div>
            {formLoading && <div style={loaderStyle}><Spinner width={16} height={16} /></div>}
          </div>

          <div style={inputGroupStyle}>
            <div style={inputWrapperStyle}>
              <TagInputs 
                onChange={handleChange} 
                disabled={!hide} 
                value={payload?.homeAddress || ''} 
                name="homeAddress" 
                label="Home Address" 
              />
            </div>
            {formLoading && <div style={loaderStyle}><Spinner width={16} height={16} /></div>}
          </div>

          <div style={inputGroupStyle}>
            <div style={inputWrapperStyle}>
              <TagInputs 
                onChange={handleChange} 
                disabled={!hide} 
                value={payload?.phone || ''} 
                name="phone" 
                label="Phone Number" 
              />
            </div>
            {formLoading && <div style={loaderStyle}><Spinner width={16} height={16} /></div>}
          </div>

          <div style={inputGroupStyle}>
            <div style={inputWrapperStyle}>
              <TagInputs 
                onChange={handleChange} 
                disabled={!hide} 
                value={payload?.email || ''} 
                name="email" 
                label="Email Address" 
              />
            </div>
            {formLoading && <div style={loaderStyle}><Spinner width={16} height={16} /></div>}
          </div>

          <div style={inputGroupStyle}>
            <div style={inputWrapperStyle}>
              <TagInputs 
                onChange={handleChange} 
                disabled={!hide} 
                value={payload?.altPhone || ''} 
                name="altPhone" 
                label="Alt Phone Number" 
              />
            </div>
            {formLoading && <div style={loaderStyle}><Spinner width={16} height={16} /></div>}
          </div>

          {hide === true && (
            <button 
              disabled={loading} 
              onClick={submitPayload} 
              className="submit-btn m-t-20 w-100"
            >
              Update
            </button>
          )}
        </div>
      </div>
    );
  }

  export default ContactDetails;
